<template>
  <div v-if="!$store.state.loading">
    <Header :image="storeInfo.image">
      {{ storeInfo.name }}
    </Header>
    <main id="#main">
      <h2 class="c-level2">
        <span>
          メニューを選ぶ
        </span>
      </h2>
      <p class="p-menu__remarks">{{ storeInfo.note.replace('\\n', '\n') }}</p>
      <ul class="p-menu__list">
        <li v-for="(menu, key, index) in storeInfo.menus" :key="index">
          <input type="checkbox" :id="menu.id" :value="menu.id" v-model="targetMenuId" @change="selectMenu()">
          <label :for="menu.id">
            <div class="p-menu__info">
              <p class="p-menu__name">{{ menu.name }}</p>
              <p class="p-menu__time">目安施術時間：{{ minToHour(menu.minutes) }}</p>
            </div>
            <p class="p-menu__price">¥{{ menu.price.toLocaleString() }}</p>
          </label>
        </li>
      </ul>
      <div class="c-fixedbtn--bottom" v-if="targetMenuId.length > 0">
        <router-link tag="p" :to="{ name: 'time', params: {} }" class="c-btn--primary">
          予約可能な時間を確認する
        </router-link>
      </div>
      <div class="c-fixedbtn--bottom" v-else>
        <p class="c-btn--primary c-btn--disabled">
          予約可能な時間を確認する
        </p>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { mapState, mapActions } from 'vuex'
import { Mixin } from '@/mixin'

export default {
  name: 'app',
  data () {
    return {
      targetMenuId: []
    }
  },
  head: {
    title: function () {
      return {
        inner: this.storeInfo.name,
        separator: '|',
        complement: 'メニュー選択'
      }
    }
  },
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapState({
      storeInfo: 'storeInfo',
      targetMenu: 'targetMenu'
    })
  },
  beforeRouteEnter (route, redirect, next) {
    next(async vm => {
      const promises = []
      const targetDate = new Date()
      const monday = targetDate.getDay() !== 0 ? targetDate.getDate() - targetDate.getDay() + 1 : targetDate.getDate() - targetDate.getDay() - 6
      const mondayDiff = targetDate.getDate() - monday
      targetDate.setDate(targetDate.getDate() - mondayDiff)
      const date = targetDate.getFullYear() + ('0' + (targetDate.getMonth() + 1)).slice(-2) + ('0' + targetDate.getDate()).slice(-2)
      vm.$store.commit('SET_LOADING', true)
      promises.push(vm.$store.dispatch('LOAD_STORE_INFO', { storeid: route.params.storeid }))
      promises.push(vm.$store.dispatch('LOAD_CALENDAR_INFO', { storeid: route.params.storeid, date: date }))
      await Promise.all(promises).then(function () {
        vm.$emit('updateHead')
        vm.$store.commit('SET_LOADING', false)
      }).catch(function (error) {
        vm.$store.commit('SET_LOADING', false)
        alert(error.message)
      })
    })
  },
  mixins: [Mixin],
  methods: {
    ...mapActions(['LOAD_STORE_INFO', 'LOAD_CALENDAR_INFO']),
    selectMenu: function () {
      let menus = []
      for (let i = 0; i < this.targetMenuId.length; i++) {
        for (let j = 0; j < this.storeInfo.menus.length; j++) {
          if (this.targetMenuId[i] === this.storeInfo.menus[j].id) {
            menus.push(this.storeInfo.menus[j])
          }
        }
      }
      this.$store.commit('SET_TARGET_MENU', menus)
    }
  }
}
</script>
